import { create } from "zustand";
import { HealthPlan, MealPlan } from "../api-objects/HealthPlan";

interface PlansData {
    healthPlans: HealthPlan[] | null;
    mealPlans: MealPlan[] | null;
}

interface PlansStore {
    plans: PlansData;
    updatePlans: (updates: Partial<PlansData>) => void;
    clearPlans: () => void;
}

// Zustand store
export const usePlansStore = create<PlansStore>((set) => ({
    // Initialize from localStorage
    plans: JSON.parse(localStorage.getItem("plans") || "{}") as PlansData || {
        healthPlans: null,
        mealPlans: null,
    },

    updatePlans: (updates) => {
        set((state) => {
            const newPlans = { ...state.plans, ...updates };
            localStorage.setItem("plans", JSON.stringify(newPlans));
            return { plans: newPlans };
        });
    },

    clearPlans: () => {
        set({ plans: { healthPlans: null, mealPlans: null } });
        localStorage.removeItem("plans");
    },
}));